// extracted by mini-css-extract-plugin
export var emotics = "metamorphosis-slider-module--emotics--89b45";
export var subtitle = "metamorphosis-slider-module--subtitle--7a746";
export var title = "metamorphosis-slider-module--title--94ed7";
export var wrapper = "metamorphosis-slider-module--wrapper--b4f55";